<template>
  <div class="dx-choose-new-game dx-choose-level">
    <p class="subtitle">{{ $t('chooseLevel') }}</p>
    <div class="dx-choose-new-game__options">
      <dx-spinner :active="loading" />
      <dx-button
        v-for="item in cardLevels"
        :key="item.id"
        @click.native="onChange(item.id)"
        :default="item.id !== level"
        :info="item.id === level"
        large
        >
        {{ $t(item.name) }}
      </dx-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DxButton from './DxButton.vue'
import DxSpinner from './DxSpinner.vue'
export default {
  name: 'dx-choose-level',
  components: { DxButton, DxSpinner },
  data () {
    return {
      level: '',
      loading: true
    }
  },
  methods: {
    ...mapActions(['loadCardLevels']),
    onChange (level) {
      this.level = level
      this.$emit('change', this.level)
    }
  },
  computed: {
    ...mapGetters({
      cardLevels: 'getCardLevels'
    })
  },
  created () {
    this.loadCardLevels().then(() => {
      this.loading = false
      if (this.cardLevels[0]) {
        this.onChange(this.cardLevels[0].id)
      }
    }).catch(() => {
      this.loading = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxChooseLevel.vue